import React, { useState } from "react";
import { usersApi } from "../api/usersApi";
import { ApiError } from "../api/apiError";
import { useNavigate } from "react-router-dom";
import { toast } from "react-hot-toast";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUserPlus } from "@fortawesome/free-solid-svg-icons";

const AddUser: React.FC = () => {
  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [loading, setLoading] =
  useState(false);
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

const handleSubmit = async (
  e: React.FormEvent,
) => {
  e.preventDefault();

  if (loading) {
    return;
  }

  const normalizedFullName =
    fullName.trim();

  const normalizedEmail =
    email.trim().toLowerCase();

  const normalizedPhone =
    phoneNumber.trim();

  if (
    normalizedFullName.length < 2
  ) {
    toast.error(
      "يرجى إدخال اسم صحيح",
    );

    return;
  }

  if (
    password.length < 6
  ) {
    toast.error(
      "كلمة المرور يجب أن تحتوي على 6 أحرف على الأقل",
    );

    return;
  }

  try {
    setLoading(true);

    await usersApi.create({
      fullName:
        normalizedFullName,

      email:
        normalizedEmail,

      password,

      phoneNumber:
        normalizedPhone,

      accountType:
        "مستخدم",

      profileImageUrl:
        null,

      province:
        null,

      AccountLevel:
        null,

      language:
        "ar",

      emailVerified:
        false,
    });

    toast.success(
      "تم إنشاء الحساب بنجاح!",
      {
        duration: 3000,
        position: "top-right",
      },
    );

    navigate(
      "/dashboard/users",
    );
  } catch (error) {
    console.error(
      "Error creating user:",
      error,
    );

    if (
      error instanceof ApiError
    ) {
      if (
        error.status === 400
      ) {
        toast.error(
          error.message ||
            "بيانات الحساب غير صحيحة",
        );

        return;
      }

      if (
        error.status === 403
      ) {
        toast.error(
          "لا تمتلك صلاحية إنشاء مستخدم",
        );

        return;
      }

      if (
        error.status === 409
      ) {
        toast.error(
          error.message ||
            "البريد الإلكتروني أو رقم الهاتف مستخدم مسبقًا",
        );

        return;
      }

      toast.error(
        error.message ||
          "حدث خطأ أثناء إنشاء الحساب",
      );

      return;
    }

    toast.error(
      "تعذر الاتصال بالخادم أثناء إنشاء الحساب",
    );
  } finally {
    setLoading(false);
  }
};

  return (
    <div className="w-full mx-auto bg-white rounded-xl shadow-lg">
      {/* Header */}
      <div className="max-w-full flex items-center justify-between bg-gradient-to-r from-[#197184] to-[#269BB4] text-white px-6 py-3 rounded-t-lg shadow-md">
        <h1
          className="text-xl font-bold flex items-center gap-2"
          style={{ fontFamily: "Tajawal, sans-serif" }}
        >
          <FontAwesomeIcon icon={faUserPlus} />
          إنشاء حساب مستخدم جديد
        </h1>
      </div>

      {/* Form */}
      <form onSubmit={handleSubmit} className="p-6 space-y-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="block text-gray-600 font-semibold mb-1 font-custom">
              الاسم الكامل:
            </label>
            <input
              type="text"
              value={fullName}
              onChange={(e) => setFullName(e.target.value)}
              required
              placeholder="الاسم الكامل"
              className="w-full p-3 border rounded-lg focus:ring-2 focus:ring-blue-500 font-custom"
            />
          </div>

          <div>
            <label className="block text-gray-600 font-semibold mb-1 font-custom">
              البريد الإلكتروني :
            </label>
            <input
              type="email"
              placeholder="البريد الإلكتروني"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full p-3 border rounded-lg focus:ring-2 focus:ring-blue-500 font-custom"
              required
            />
          </div>

          <div>
            <label className="block text-gray-600 font-semibold mb-1 font-custom">
              رقم الهاتف :
            </label>
            <input
              type="text"
              placeholder="رقم الهاتف"
              value={phoneNumber}
              onChange={(e) => setPhoneNumber(e.target.value)}
              className="w-full p-3 border rounded-lg focus:ring-2 focus:ring-blue-500 font-custom"
              required
            />
          </div>


          <div>
            <label className="block text-gray-600 font-semibold mb-1 font-custom">
              كلمة المرور :
            </label>
            <input
              type="text"
              placeholder="كلمة المرور"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full p-3 border rounded-lg focus:ring-2 focus:ring-blue-500 font-custom"
              required
            />
          </div>
        </div>

        <div className="text-left mt-4">
         <button
  type="submit"
  disabled={loading}
  className="bg-[#197184] hover:bg-[#155c6e] disabled:opacity-60 text-white py-2 px-6 rounded-md shadow-md transition"
>
  {loading
    ? "جاري إنشاء الحساب..."
    : "حفظ الحساب"}
</button>
        </div>
      </form>
    </div>
  );
};

export default AddUser;
